'use client';

export default function ServiceReviewsSkeleton() {
  return (
    <section className="px-8 py-8 md:py-12 lg:py-16 bg-slate-50 dark:bg-slate-900 rounded-2xl">
      <div className="mb-8 md:mb-12 text-center">
        <div className="h-8 w-64 mx-auto mb-4 rounded bg-gray-200 dark:bg-gray-700 animate-pulse" />
        <div className="h-5 w-96 mx-auto rounded bg-gray-200 dark:bg-gray-700 animate-pulse" />
      </div>

      <div className="mb-8">
        <div className="h-24 rounded bg-gray-200 dark:bg-gray-700 animate-pulse mb-4" />
        <div className="h-6 w-48 rounded bg-gray-200 dark:bg-gray-700 animate-pulse" />
      </div>

      <div className="w-full h-[700px] rounded-lg bg-gray-200 dark:bg-gray-700 animate-pulse" />
    </section>
  );
}

